import { Component, OnInit } from '@angular/core';
import { EmpresaService } from 'src/app/empresa/empresa.service';
import { Licenca } from 'src/app/licenca/licenca.model';
import { LicencaService } from 'src/app/licenca/licenca.service';
import { AuthService } from 'src/app/seguranca/auth.service';
import { DepositoPixFilter } from '../deposito-pix-filter';
import { DepositoPix } from '../deposito-pix.model';
import { ExtratoService } from '../extrato.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-extrato-deposito-pix',
  templateUrl: './extrato-deposito-pix.component.html',
  styleUrls: ['./extrato-deposito-pix.component.css']
})
export class ExtratoDepositoPixComponent implements OnInit {

  jwtPayload: any;
  moeda: string;
  exibir: boolean;
  maxDate: Date;
  resumo: any;

  empresasOptions: any[];

  licencas: Licenca[];
  licencasOptions: any[];
  licencaSelected: Licenca;

  depositoPixFilter: DepositoPixFilter;
  depositoPixList: DepositoPix[];
  depositoPixSelected: DepositoPix;

  constructor(
    private authservice: AuthService,
    private empresaService: EmpresaService,
    private licencaService: LicencaService,
    private extratoService: ExtratoService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.maxDate = new Date();
    this.jwtPayload = this.authservice.getJwtPayload();
    this.depositoPixFilter = new DepositoPixFilter(this.jwtPayload.usuarioEmpresaId);

    this.empresaService.getEmpresas().subscribe(
      result => {
        this.empresasOptions = [];
        result.forEach(empresa => {
          let name = empresa.nomeFantasia;
          if (empresa.type === 'PF') {
            name = empresa.razaoSocial + ' ' + name;
          } else {
            name = empresa.razaoSocial + ' | ' + name;
          }
          this.empresasOptions.push(
            { label: name.toUpperCase(), value: empresa.id, ativa: empresa.ativa }
          );
        });
      },
      err => {
        console.log('Error:', err);
      },
      () => {
        this.empresasOptions.sort(function (a, b) {
          if (a.label > b.label) {
            return 1;
          }
          if (a.label < b.label) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        this.buscarLicencas();
      }
    );
  }

  buscarLicencas() {
    this.depositoPixFilter.licencaId = undefined;
    this.licencaService.buscarPorEmpresa(this.depositoPixFilter.empresaId).subscribe(
      licencas => {
        this.licencas = licencas;
        this.licencasOptions = [];
        for (let licenca of licencas) {
          if (this.depositoPixFilter.empresaId === this.jwtPayload.usuarioEmpresaId && this.jwtPayload.licencasPermitidas.length > 0 && !this.jwtPayload.licencasPermitidas.includes(licenca.id)) {
            continue;
          }
          if (licenca.moeda === 'BRL') {
            this.licencasOptions.push(
              { label: licenca.contrato, value: licenca.id }
            );
            if (this.depositoPixFilter.licencaId === undefined) {
              this.depositoPixFilter.licencaId = licenca.id;
              this.moeda = licenca.moeda;
            }
          }
        }
      },
      err => {
        console.log('Error:', err);
      },
      () => {
        this.depositoPixFilter.initRangeDates();
        this.depositoPixFilter.status = 'ATIVO';
        this.buscar();
      }
    );
  }

  alterarLicenca() {
    this.depositoPixFilter.initRangeDates();
    this.depositoPixFilter.status = 'ATIVO';
    this.buscar();
  }

  buscar() {
    console.log('this.depositoPixFilter.getSearchParams()', this.depositoPixFilter.getSearchParams());
    this.extratoService.getDepositosPix(this.depositoPixFilter).subscribe(
      result => {
        console.log('Depositos:', result);
        this.depositoPixList = result;
      },
      error => {
        console.log('Error:', error);
        this.depositoPixList = [];
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao consultar!',
          detail: 'Erro ao consultar depositos.'
        });
      },
      () => {
        this.depositoPixFilter.clear();
        this.resumo = {
          qtd: 0,
          vlr: 0,
          situacoes: []
        }
        for (const pix of this.depositoPixList) {
          let situacao = undefined;
          for (const s of this.resumo.situacoes) {
            if (s.status === pix.status) {
              situacao = s;
              break;
            }
          }
          if (situacao) {
            situacao.qtd++;
            situacao.vlr += pix.valor;
          } else {
            this.resumo.situacoes.push({
              status: pix.status,
              qtd: 1,
              vlr: pix.valor
            });
          }
          this.resumo.qtd++;
          this.resumo.vlr += pix.valor;
        }
        this.resumo.situacoes.sort(function (s1, s2) {
          if (s1.status > s2.status) {
            return 1;
          }
          if (s1.status < s2.status) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        console.log('this.resumo', this.resumo);
      }
    );
  }

  onRowSelect(depositoPix: DepositoPix) {
    if (this.hasPermission('DEPPIX_VISUALIZAR')) {
      this.depositoPixSelected = depositoPix;
      console.log('this.depositoPixSelected', this.depositoPixSelected);
      console.log('this.licencas', this.licencas);
      this.licencas.forEach(licenca => {
        if (this.depositoPixSelected.licencaId === licenca.id) {
          this.licencaSelected = licenca;
        }
      });
      this.exibir = true;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Permissão Negada!',
        detail: 'Você não possui permissão para visualizar detalhes do PIX.'
      });
    }
  }

  alterarTipoPeriodo() {
    if (this.depositoPixFilter.tpPeriodo === 'P') {
      this.depositoPixFilter.status = 'PAGO';
    }
  }

  gerarPix() {
    console.log('this.depositoPixFilter', this.depositoPixFilter);
    console.log('this.licencas', this.licencas);
    console.log('this.jwtPayload', this.jwtPayload);
    this.licencas.forEach(licenca => {
      if (this.depositoPixFilter.licencaId === licenca.id) {
        this.licencaSelected = licenca;
      }
    });
    this.depositoPixSelected = new DepositoPix(this.depositoPixFilter.empresaId);
    this.depositoPixSelected.licencaId = this.depositoPixFilter.licencaId;
    this.depositoPixSelected.user = this.jwtPayload.usuarioNome;
    this.exibir = true;
  }

  onPixCreated(depositoPix: DepositoPix) {
    console.log('onPixCreated', depositoPix);
    this.depositoPixList.unshift(depositoPix);
  }

  hasPermission(permission: string) {
    return this.jwtPayload.authorities.includes(permission);
  }

}
